import type { SessionStore } from "../store/session";

/**
 * WHERE THE APP OPENS — `main.tsx`'s routing, decided before the first render (extracted so it can be
 * driven by a test: `bootstrap()` itself cannot be mounted).
 *
 * 1. A `t_<game>_<roomId>` table link (Telegram `startapp`) opens that table; an `f_`/`c_` link is
 *    stashed for after the boot (`routeFromStartParam`).
 * 2. STRAIGHT BACK TO A HELD PUBLIC SEAT (card-a5 item 1, operator 2026-10-11): «reopening the app
 *    while the seat is still held goes straight back to the table». Asked LAST, so a held seat wins
 *    over the link the app was opened with (one public game at a time), and here — before the first
 *    render — so the table is the first screen whatever the entry (the menu button, a reload, a deep
 *    link) and the boot splash never shows in front of it. The return is a `rejoin`, which App renders
 *    before the boot is done and which skips every gate a resume skips; one that fails is silent
 *    (`OnlineGame`). See `game/straight-back.ts`.
 *
 * Never in the share-invite mode, which renders nothing but that screen.
 */
export function routeAppOpen(
  store: SessionStore,
  startParam: string | null | undefined,
  shareInviteMode: boolean,
): void {
  store.getState().routeFromStartParam(startParam);
  if (!shareInviteMode) store.getState().returnToHeldTable();
}
